import { useState, useEffect } from 'react';
import BaseMarkdown from '@components/base/BaseMarkdown';
import useI18n, { LocaleTypes } from '@i18n';

import privacyEpnRU from './content_ru.md';
import privacyEpnEN from './content_en.md';

const PRIVACY_MAP = {
    [LocaleTypes.ru]: privacyEpnRU,
    [LocaleTypes.en]: privacyEpnEN,
};

const RulesMarkdown: React.FC = () => {
    const { locale } = useI18n();
    const [markdown, setMarkdown] = useState<string>('');

    useEffect(() => {
        if (locale === LocaleTypes.ru) {
            setMarkdown(PRIVACY_MAP.ru);
        } else {
            setMarkdown(PRIVACY_MAP.en);
        }
    }, [locale]);

    return <BaseMarkdown markdown={markdown} />;
};

export default RulesMarkdown;
